import React from 'react'
import {t} from '../../helpers/translate'
import {Well} from 'react-bootstrap'

class PaypalComponent extends React.Component {

  render() {
    return <Well>{t('This is a placeholder for Paypal.')}</Well>
  }
}

PaypalComponent.displayName = 'PaypalComponent';
export default PaypalComponent;



// WEBPACK FOOTER //
// ./src/components/common/PaypalComponent.js